<template>
  <div>
    <header-applis titre="Adapter l’offre à votre expérience" index-progression-courante="2"/>
    <div class="wrapper__content">
      <ul class="app-votre-experience">
        <li class="app-votre-experience--item">
          <qualification id="experience" titre="Mon expérience" :qualification="experienceProche" :possede-qualification="possedeExperienceProche"
                         label="« Je dispose d’une expérience et/ou d’une formation proche(s) et/ou complémentaire(s) au diplôme »"
                         @input="inputPossedeExperienceProche" @textarea="textareaExperienceProche" labelTextArea="Laquelle ?"/>
        </li>
        <li class="app-votre-experience--item">
          <qualification id="diplome" titre="Mes diplômes" :qualification="diplomeProche" :possede-qualification="possedeDiplomeProche"
                         label="« Je possède le diplôme requis pour accéder à la formation* »"
                         @input="inputPossedeDiplomeProche" @textarea="textareaDiplomeProche" labelTextArea="Lequel ?"/>
          <div>
            <span>* Vous trouverez des précisions sur les conditions d’admission en consultant les pages web du diplôme / de la formation</span>
          </div>
        </li>
      </ul>
    </div>
    <footer-applis ecran-precedent="confirmation" :ecran-suivant="ecranSuivant()" label-suivant="Je confirme et je passe à la suite"/>
  </div>
</template>

<script>
import HeaderApplis from '../components/HeaderApplis';
import FooterApplis from '../components/FooterApplis';
import Qualification from '../components/Qualification';

export default {
  name: 'qualificationexperiencediplome',
  components: {
    Qualification,
    FooterApplis,
    HeaderApplis
  },
  data() {
    return {
      possedeExperienceProche: false,
      experienceProche: '',
      possedeDiplomeProche: false,
      diplomeProche: '',
    }
  },
  computed: {
    /**
     * Récupération des informations de parcours.
     * @returns {Object} Les informations de parcours.
     */
    informationsParcours() {
      return this.$store.getters.getInformationsParcours;
    }
  },
  methods: {
    inputPossedeExperienceProche(value) {
      this.possedeExperienceProche = value;
      if (!this.possedeExperienceProche) {
        this.experienceProche = '';
      }
    },
    textareaExperienceProche(value) {
      this.experienceProche = value;
    },
    inputPossedeDiplomeProche(value) {
      this.possedeDiplomeProche = value;
      if (!this.possedeDiplomeProche) {
        this.diplomeProche = '';
      }
    },
    textareaDiplomeProche(value) {
      this.diplomeProche = value;
    },
    /**
     * Récupération du nom de l'écran suivant en fonction de la valeur sélectionnée par l'utilisateur.
     * @returns {string} Le nom de l'écran.
     */
    nomEcranSuivant() {
      if (!this.informationsParcours.possedeExperienceProche && !this.informationsParcours.possedeDiplomeProche) {
        return 'diplomenonaccessible';
      } else if ((this.informationsParcours.possedeExperienceProche && !this.experienceProche)
          || (this.informationsParcours.possedeDiplomeProche && !this.diplomeProche)) {
        return '';
      } else {
        return 'competencestransversales';
      }
    },
    /**
     * Méthode de passage à l'écran suivant. Permet de faire les vérifications de saisie.
     */
    ecranSuivant() {
      let possedeExperienceProche = this.possedeExperienceProche;
      let experienceProche = this.experienceProche;
      let possedeDiplomeProche = this.possedeDiplomeProche;
      let diplomeProche = this.diplomeProche;
      this.$store.commit('setExperienceEtDiplome', {
        possedeExperienceProche,
        experienceProche,
        possedeDiplomeProche,
        diplomeProche
      });
      return this.nomEcranSuivant();
    },
  },
  created() {
    this.possedeExperienceProche = this.informationsParcours.possedeExperienceProche;
    this.experienceProche = this.informationsParcours.experienceProche;
    this.possedeDiplomeProche = this.informationsParcours.possedeDiplomeProche;
    this.diplomeProche = this.informationsParcours.diplomeProche;
  }
}
</script>

<style scoped>
ul {
  list-style: none;
}

textarea {
  width: 90%;
}

.app-votre-experience {
  display: flex;
  flex-wrap: wrap;
}

.app-votre-experience--item {
  margin-bottom: 2.5em;
}

.app-votre-experience--item:last-child {
  margin-bottom: 0;
}

@media (min-width: 932px) {
  .app-votre-experience--item {
    width: 50%;
    margin-bottom: 0;
  }
}
</style>